module.exports = __webpack_public_path__ + "img/lucas-artist copy.5a257537.jpg";